import React from 'react'
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom'
import MQuestions from './MythQ'
import './style.css'
import MResults from './mythsResults.js'
import database from '../../database.js'
import {Loading} from '../generic.js';

export default class QuizSection extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      score: 0,
      currentQ: -1,
      gotWrongAnswer: false,
      hasAnswered: false,
      hasFinished: false,
      myths: null,
      correctionText: "",
    }
    this.onAnswer = this.onAnswer.bind(this)
  }

  componentWillMount () {
    database.collection('myths').get().then(function (qs) {
      let newQuestions = [];
      qs.docs.forEach(function (doc, i) {
        newQuestions[i] = {
          myth: doc.data().myth,
          fact: doc.data().fact,
          text: doc.data().text,
        }
      })
      this.setState({
        myths: newQuestions,
      })
    }.bind(this))
      .catch(function (error) {
        console.log(error)
    })
  }

  endQuiz () {
    this.setState({
      hasFinished: true
    })
  }

  onAnswer (answer,  currentOrder, history) {
    if (answer === true) {
      this.setState({score: this.state.score + 1})
    } else {
      this.setState({gotWrongAnswer: true})
    }
  }

  nextQuestion(currentOrder, history) {
    this.setState({correctionText: ""});
    this.setState({gotWrongAnswer: false});
    this.setState({hasAnswered: false});
    if (parseInt(currentOrder, 0) === this.state.myths.length - 1) {
      history.push('/*/quiz/myths/results')
    } else {
      history.push('/*/quiz/myths/' + (parseInt(currentOrder, 0) + 1))
    }
  }

  render () {
    let score = this.state.score;
    if (this.state.myths) {
      return (
          <div className={this.props.location.pathname === ('/youth/quiz/myths')?'screen-container-youth':'screen-container'}>
            <Router>
                <span>
                  <Switch>
                <Route path='/*/quiz/myths/results' render={() => {
                  return <MResults score={this.state.score} />
                }} />
                <div className='questions-container'>
                  <Route exact path='/*/quiz/myths' render={({match, location, history}) => {
                    return (
                      <QuizIntro onAnswer={() => {
                        this.nextQuestion(-1, history)
                      }} />
                    )
                  }} />
                <Route path='/*/quiz/myths/:order' render={({match, location, history}) => {

                  return (
                    <div >
                      <h1>Score: {this.state.score}/{this.state.myths.length}</h1>
                      <MQuestions
                        myth={this.state.myths[match.params.order].myth}
                        fact={this.state.myths[match.params.order].fact}
                        text={this.state.myths[match.params.order].text}
                        order={match.params.order}
                        history={history}
                        onNextQuestion={() => {
                          this.nextQuestion(match.params.order, history);
                        }}
                        onAnswer={(ans) => {
                          this.setState({hasAnswered: true});
                          if (ans === true) {
                            this.setState({correctionText: "Well done! " + this.state.myths[match.params.order].text});
                            this.onAnswer(
                              ans,
                              match.params.order,
                              history)
                            } else {
                              this.setState({correctionText: "Not quite. " + this.state.myths[match.params.order].text});
                            }
                        }} />
                      <p>{this.state.correctionText}</p>
                    </div>
                  )
                }} />
              </div>

              </Switch>
            </span>
            </Router>
          </div>

      )
    } else {
      return (<Loading />)
    }
  }
}

class QuizIntro extends React.Component {
  constructor (props) {
    super(props)
    this.props = props
  }

  render () {
    return (
      <span>
        <p className='introduction'>
        The Myth Buster Quiz is a short quiz to test your understanding of the common myths that surround mental health difficulties. 
        <br/>Read each statement and decide whether it is ‘true’ or ‘false’ and then click the ‘check’ button to check your answer. 
        </p>

        <button type='button' className={'next-question-button btn btn-block btn-success'} onClick={() => {
            this.props.onAnswer()     
        }}>Next »</button>
      </span>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Quiz/myths.js